import { Pipe, PipeTransform } from '@angular/core';
import { RedoneStatusHelper } from '../enum-helpers/redone-status.enum.helper';
import { RedoneStatus } from '../enums/redone-status.enum';

@Pipe({ name: 'redoneStatus' })
export class RedoneStatusPipe implements PipeTransform {
  public transform(value: RedoneStatus): string | null | undefined {
    if (!value && value !== 0) {
      return null;
    }

    const enumTranslated = RedoneStatusHelper.translateEnum(value);
    return enumTranslated;
  }
}
